export function load(src, opts = {}) {
  let s = document.querySelector(`script[src="${src}"]`);
  if (s) return s;

  s = document.createElement("script");
  s.src = src;
  // set some attributes
  Object.keys(opts).forEach((key) => (s[key] = opts[key]));
  document.body.appendChild(s);
  return s;
}

export function generateRandomString(length) {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

export function removeDiacritics(str) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
